module.exports = {
      id: "email-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#email",
      toString: function () {
        return this.url;
      }
    }